import { ReactNode } from 'react'
import { Grid, Typography, Box, makeStyles, Theme } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import { useFormikContext } from 'formik'
import {
  useProductFromQueryParam,
  SemiConfiguratorSpeciesList,
  SemiConfigFormValues,
  getInitialValuesBasedOnProduct,
} from '../ProductsConfiguration'
import SpeciesSelectionBox from '@src/routes/Configurators/components/SpeciesSelectionBox'
import useSearch from '../useSearch'

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    paddingTop: theme.spacing(8),
  },
  instructions: {
    paddingTop: theme.spacing(6),
    '& h6': {
      fontWeight: 700,
    },
  },
  selectionBox: {
    paddingTop: theme.spacing(4),
  },
  item: {
    flexBasis: '100%',
    [theme.breakpoints.up('sm')]: {
      flexBasis: '100%',
      maxWidth: '50%',
    },
    [theme.breakpoints.up('md')]: {
      flexBasis: 'calc(50% - 16px)',
    },
    [theme.breakpoints.up('lg')]: {
      flexBasis: 'calc(33% - 8px)',
    },
    [theme.breakpoints.up('xl')]: {
      flexBasis: 'calc(25% - 16px)',
    },
  },
  speciesSelectionBoxContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '16px',
  },
}))

const Species = () => {
  const product = useProductFromQueryParam()
  const classes = useStyles()
  const formik = useFormikContext<SemiConfigFormValues>()
  const { searchQuery } = useSearch()
  const initialValues = getInitialValuesBasedOnProduct(product)
  const listSpecies: { name: string; label: ReactNode }[] =
    SemiConfiguratorSpeciesList[product] || []

  const onSpeciesChange = async ({ name, checked }) => {
    let updatedFacet: string[] = []
    if (checked) {
      updatedFacet = formik.values.searchData.facet.filter(
        (facet) => facet !== `species:${name}`
      )
    } else {
      updatedFacet = [...formik.values.searchData.facet, `species:${name}`]
    }
    formik.setFieldValue('searchData.facet', updatedFacet, false)
    formik.setFieldValue('selectedClones', [], false)
    formik.setFieldValue('specifications', initialValues.specifications, false)
    formik.setFieldValue('searchData.page', 1, false)
    //trigger search
    await searchQuery({ facet: updatedFacet })
  }

  const checkForSpeciesChecked: (e: string) => boolean = (species) => {
    const facet = formik.values.searchData.facet
    return facet.includes(`species:${species}`)
  }

  return (
    <Grid container className={classes.container}>
      <Grid item xs={12}>
        <Typography variant="h3">
          <FormattedMessage id="SPECIES" defaultMessage="Species" />
        </Typography>
      </Grid>
      <Grid item xs={12} className={classes.instructions}>
        <Typography variant="subtitle1">
          <FormattedMessage
            id="SELECT_A_SPECIES"
            defaultMessage="Select a Species"
          />
        </Typography>
      </Grid>
      <Grid item xs={12} className={classes.selectionBox}>
        <Box className={classes.speciesSelectionBoxContainer}>
          {listSpecies.map((species, index) => (
            <Box key={index} className={classes.item}>
              <SpeciesSelectionBox
                name={species.name}
                label={species.label}
                checked={checkForSpeciesChecked(species.name)}
                clickHandler={onSpeciesChange}
                multiSelect
              />
            </Box>
          ))}
        </Box>
      </Grid>
    </Grid>
  )
}

export default Species
